import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { fetchLocationCategoryArticles } from './../../actions.js';
import { getLocationArticles } from './actions';
import { LoadMore } from './../../../ui/src/component/loadMore';
import { ArticleTiles } from './../../../ui/src/component/articleTiles';
import { StandardArticleCustom } from './../../component/standardArticleCustom';
import { Icon } from './../../../ui/src/component/icon';
import { CsmSectionLink } from './../../../ui/src/component/csmSectionLink';
import { CsmArticlePanorama } from './../../../ui/src/component/csmArticlePanorama';
import { Helmet } from 'react-helmet';
import { getProp } from '../../../ui/src/utilities';
import { SectionName } from '../../../ui/src/component/csmSectionLink/csmSectionLink.js';

class LocationDetail extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      id: this.props.params.locationId,
    };
  }

  componentDidMount() {
    LocationDetail.fetchArticles(
      this.props.dispatch,
      this.state.id,
      0,
      11,
    ).catch(() => {});
    LocationDetail.fetchLocationCategories(
      this.props.dispatch,
      this.state.id,
    ).catch(() => {});
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.params.locationId !== this.state.id) {
      this.setState({ id: nextProps.params.locationId }, () => {
        LocationDetail.fetchArticles(this.props.dispatch, this.state.id, 0, 11);
        LocationDetail.fetchLocationCategories(
          this.props.dispatch,
          this.state.id,
        );
      });
    }
  }

  static fetchArticles(dispatch, locationId, offset, limit) {
    return dispatch(
      getLocationArticles(process.env.REACT_APP_CONTENT_SPACE, locationId, {
        smarttags: `location:${locationId}`,
        offset,
        limit,
        sorter: 'pin2locality',
      }),
    );
  }

  static fetchLocationCategories(dispatch, locationId) {
    return dispatch(fetchLocationCategoryArticles(locationId));
  }

  onLoadMore() {
    return LocationDetail.fetchArticles(
      this.props.dispatch,
      this.state.id,
      this.props.articlesNextOffset,
      8,
    );
  }

  render() {
    let featuredArticles = [];
    let otherArticles = [];
    if (this.props.articles.length > 3) {
      featuredArticles = this.props.articles.slice(0, 3);
      otherArticles = this.props.articles.slice(3);
    } else {
      otherArticles = this.props.articles;
    }

    let articleTilesContainerStyle = {};
    articleTilesContainerStyle['paddingTop'] = 0;

    let name = '';
    for (let tag of this.props.locationSmartTags) {
      if (tag.id === this.state.id) {
        name = tag.title;
        break;
      }
    }

    return (
      <div>
        <Helmet>
          <title>{name}</title>
        </Helmet>

        <CsmArticlePanorama article={{ name }} />

        {featuredArticles.length === 3 ? (
          <div
            className="bg-alt-light section"
            style={articleTilesContainerStyle}
          >
            <div className="container">
              <ArticleTiles
                articles={featuredArticles.map(item => (
                  <StandardArticleCustom pictureSize={1000} article={item} />
                ))}
              />
            </div>
          </div>
        ) : null}

        <div className="section">
          {otherArticles.length > 0 ? (
            <div className="container">
              <div className="row flex-row">
                {otherArticles.map(item => {
                  return (
                    <div
                      key={item._id}
                      className="flex-col col-xs-12 col-sm-6 col-md-3"
                    >
                      <StandardArticleCustom extended={true} article={item} />
                    </div>
                  );
                })}
              </div>
            </div>
          ) : null}

          {this.props.articlesNextOffset !== null ? (
            <div className="text-center section">
              <LoadMore
                show={
                  !this.props.articleLoading &&
                  this.props.articlesNextOffset !== null
                }
                onClick={this.onLoadMore.bind(this)}
              />
            </div>
          ) : null}

          <div className="container">
            {this.props.locationCategories.map(section => {
              const articles = getProp(section, 'articles.articles', []);
              if (articles.length === 0) {
                return null;
              }
              return (
                <div key={section._id}>
                  <CsmSectionLink
                    section={section}
                    params={{
                      lokalita: this.state.id,
                    }}
                  >
                    <h2 className="h1">
                      <SectionName>{section.name}</SectionName>{' '}
                      <span className="text-primary">{name}</span>{' '}
                      <Icon name="chevron-circle-right" className="icon-md" />
                    </h2>
                  </CsmSectionLink>
                  <div className="row flex-row">
                    {articles.map(item => {
                      return (
                        <div
                          key={item._id}
                          className="flex-col col-xs-12 col-sm-6 col-md-3"
                        >
                          <StandardArticleCustom article={item} />
                        </div>
                      );
                    })}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    );
  }
}

LocationDetail.fetchData = ({ store, renderProps: { location, params } }) => {
  const locationId = params.locationId;
  return Promise.all([
    LocationDetail.fetchArticles(store.dispatch, locationId, 0, 11),
    LocationDetail.fetchLocationCategories(store.dispatch, locationId),
  ]);
};

LocationDetail.propTypes = {
  dispatch: PropTypes.func.isRequired,
  params: PropTypes.object.isRequired,
  articles: PropTypes.array.isRequired,
  articlesNextOffset: PropTypes.number,
  articleLoading: PropTypes.bool,
  locationSmartTags: PropTypes.array.isRequired,
  locationCategories: PropTypes.array.isRequired,
};

export default connect((state, props) => {
  const locationId = props.params.locationId;
  const articlesDomain = state.locationArticles;
  let articles = [];
  let articlesNextOffset = null;
  let articleLoading = false;
  if (articlesDomain.byLocationId[locationId]) {
    const locationArticlesDomain = articlesDomain.byLocationId[locationId];
    articles = locationArticlesDomain.articles || [];
    articlesNextOffset = locationArticlesDomain.nextOffset || null;
    articleLoading = locationArticlesDomain.isFetching || false;
  }
  return {
    articles,
    articlesNextOffset,
    articleLoading,
    locationSmartTags: state.locationSmartTags.data.values,
    locationCategories: state.locationCategories.data.sections,
  };
})(LocationDetail);



// WEBPACK FOOTER //
// ./src/app/container/locationDetail/index.js